module.exports = __webpack_public_path__ + "build/img/03.8558a507.jpg";